import { render, staticRenderFns } from "./myPrize.vue?vue&type=template&id=3ab6f2c3&scoped=true&"
import script from "./myPrize.vue?vue&type=script&lang=js&"
export * from "./myPrize.vue?vue&type=script&lang=js&"
import style0 from "./myPrize.vue?vue&type=style&index=0&id=3ab6f2c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab6f2c3",
  null
  
)

export default component.exports